// Estilos y handlers de interacción (hover/press/focus) de HomeScreen.
// Extraído de HomeScreen.js para mantenerlo más liviano.

const leaderboardButtonBase = {
  borderRadius: 10,
  padding: '6px 10px',
  background: 'rgba(255,255,255,0.55)',
  border: '1px solid rgba(75,0,130,0.25)',
  color: '#4B0082',
  fontWeight: 800,
  cursor: 'pointer',
  backdropFilter: 'blur(4px)',
  WebkitBackdropFilter: 'blur(4px)',
};

const supportFabStyle = {
  position: 'fixed',
  right: 18,
  bottom: 86, // por encima del botón de Trivia (que está en bottom: 18)
  zIndex: 10010,
  borderRadius: 999,
  padding: '8px 14px',
  background: 'linear-gradient(135deg, #DAA520, #FFD700)',
  color: '#4B0082',
  border: 'none',
  boxShadow: '0 8px 20px rgba(0,0,0,0.35)',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 900,
  fontSize: 14,
};

const feedFabStyle = {
  position: 'fixed',
  right: 'calc(env(safe-area-inset-right, 0px) - 2px)',
  top: 'calc(env(safe-area-inset-top, 0px) + 250px)',
  transform: 'translateY(0)',
  zIndex: 10075,
  width: 74,
  minHeight: 158,
  borderRadius: 22,
  padding: '12px 7px',
  background:
    'radial-gradient(120px 120px at 16% 18%, rgba(255,255,255,0.16), rgba(255,255,255,0) 58%),' +
    'radial-gradient(150px 120px at 84% 16%, rgba(255,215,0,0.16), rgba(255,215,0,0) 64%),' +
    'linear-gradient(180deg, rgba(255,215,0,0.97), rgba(230,184,0,0.96), rgba(75,0,130,0.96))',
  color: '#4B0082',
  border: '1px solid rgba(255,215,0,0.34)',
  boxShadow:
    '0 22px 48px rgba(0,0,0,0.42), 0 0 0 1px rgba(255,215,0,0.12) inset, 0 0 32px rgba(255,215,0,0.12), 0 0 22px rgba(75,0,130,0.22)',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 6,
  backdropFilter: 'blur(16px)',
  WebkitBackdropFilter: 'blur(16px)',
  userSelect: 'none',
  touchAction: 'manipulation',
  overflow: 'hidden',
  isolation: 'isolate',
};

// === Zodiac Crush: floating entry button (Home) ===
const zodiacCrushFabStyle = {
  position: 'fixed',

  // ✅ Visible, premium, and NEVER covers the central card.
  // Keep it slightly inside the viewport (not glued to the edge).
  left: 'calc(env(safe-area-inset-left, 0px) + 10px)',
  top: 'calc(env(safe-area-inset-top, 0px) + 96px)', // SUBIDO: 128px -> 96px
  zIndex: 10070,

  // Compact vertical edge-pill (less "container sobrante")
  width: 58,
  height: 104,
  borderRadius: 18,
  padding: '8px 8px',

  // Dorado como base + glow violeta
  background:
    'radial-gradient(90px 120px at 30% 25%, rgba(75,0,130,0.45), rgba(75,0,130,0.00) 58%),' +
    'linear-gradient(180deg, #FFD700, #E6B800 55%, #C9A200)',

  color: '#4B0082',
  border: '1px solid rgba(75,0,130,0.55)',
  boxShadow:
    '0 18px 46px rgba(0,0,0,0.42), 0 0 0 1px rgba(75,0,130,0.25) inset, 0 0 26px rgba(75,0,130,0.45)',

  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  fontWeight: 950,
  letterSpacing: 0.25,

  backdropFilter: 'blur(10px)',
  WebkitBackdropFilter: 'blur(10px)',
  userSelect: 'none',
  touchAction: 'manipulation',
};

const forumBellFabStyle = {
  position: 'fixed',
  // ✅ Needed so the badge (position: absolute) anchors to this button
  overflow: 'visible',
  // ✅ Top-right, aligned with the header/profile area
  right: 'calc(env(safe-area-inset-right, 0px) + 16px)',
  top: 'calc(env(safe-area-inset-top, 0px) + 62px)',
  // ensure we are not using bottom positioning
  bottom: 'auto',
  left: 'auto',
  zIndex: 10080,
  width: 44,
  height: 44,
};

const forumBellBadgeStyle = {
  position: 'absolute',
  top: -4,
  right: -4,
  minWidth: 18,
  height: 18,
  padding: '0 5px',
  borderRadius: 999,
  background: 'linear-gradient(135deg, #DAA520, #FFD700)',
  color: '#4B0082',
  border: '1px solid rgba(0,0,0,0.25)',
  fontWeight: 900,
  fontSize: 11,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: 1,
  boxShadow: '0 6px 14px rgba(0,0,0,0.25)',
};

// Estilos cuando el botón está activo / seleccionado
const leaderboardButtonActive = {
  background: 'linear-gradient(135deg,#FFF3BF,#FFE066)',
  border: '2px solid #DAA520',
};

const hoverIn = (e) => {
  // No aplicar hover en dispositivos táctiles
  if (typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(hover: none)').matches) return;
  e.currentTarget.style.transform = 'scale(1.02)'; // un poco menos de escala
  e.currentTarget.style.boxShadow = '0 8px 24px rgba(218,165,32,0.4)';
  e.currentTarget.style.backgroundImage =
  'linear-gradient(135deg, #FFE34D 0%, #FFC400 45%, #FFF176 100%)';
};

const hoverOut = (e) => {
  e.currentTarget.style.transform = 'scale(1)';
  e.currentTarget.style.boxShadow = buttonStyle.boxShadow;
  // Quitar solo el gradiente sin tocar el backgroundColor base
  e.currentTarget.style.backgroundImage = '';
};

const pressIn = (e) => {
  e.currentTarget.style.transform = 'scale(0.985)';
};
const pressOut = (e) => {
  e.currentTarget.style.transform = 'scale(1)';
};

const focusIn = (e) => {
  // Anillo de enfoque dorado accesible
  e.currentTarget.style.outline = 'none';
  e.currentTarget.style.boxShadow = '0 0 0 3px rgba(218,165,32,0.5), 0 8px 24px rgba(218,165,32,0.35)';
};
const focusOut = (e) => {
  // Restaurar sombra base
  e.currentTarget.style.outline = '';
  e.currentTarget.style.boxShadow = buttonStyle.boxShadow;
};

const containerStyle = {
  minHeight: '100svh',
  height: '100svh',
  width: '100%',
  background: 'transparent',
  color: '#fff',
  display: 'grid',
  placeItems: 'start center',
  justifyItems: 'center',
  alignContent: 'start',
  textAlign: 'center',
  padding: 'clamp(12px, 4vw, 24px)',
  paddingTop: 'clamp(18px, 7vh, 48px)',
  paddingBottom: 'env(safe-area-inset-bottom)',
  boxSizing: 'border-box',
  overflowY: 'visible',            // deja que el scroll lo maneje la página
  overflowX: 'hidden',
  scrollbarGutter: 'stable both-edges',
  touchAction: 'auto',
  gap: 'clamp(14px, 3.2vw, 22px)',
};

const overlayStyle = {
  // Overlay ultraligero: no oscurece la rueda de fondo
  background: 'linear-gradient(180deg, rgba(255, 215, 0, 0.02), rgba(255,255,255,0.03))',
  minHeight: '100%',
  border: '1px solid rgba(218,165,32,0.35)',
  borderRadius: '24px',
  boxShadow: '0 6px 18px rgba(0, 0, 0, 0.08)',
  padding: 'clamp(14px, 3vw, 24px)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: 'min(680px, 92vw)',
  maxWidth: '92vw',
  overflow: 'visible',
  margin: '0 auto',
  backdropFilter: 'none',           // sin blur: no tapa el fondo
  WebkitBackdropFilter: 'none',
  boxSizing: 'border-box',
  gap: 'clamp(8px, 2.4vw, 16px)',
  mixBlendMode: 'normal',           // evita oscurecimientos por mezcla
};

const buttonStyle = {
  width: '100%',
  maxWidth: 300,
  minHeight: 52,
  padding: 'clamp(0.8rem, 2.6vw, 1rem)',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  cursor: 'pointer',
  fontWeight: 800,
  fontSize: '1rem',
  borderRadius: '12px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  touchAction: 'manipulation',

  /* 🎨 DORADO translúcido SIEMPRE (igual en celular/desktop) */
  backgroundColor: 'rgba(255,215,0,0.75)',
  backgroundImage: 'linear-gradient(135deg, rgba(255,215,0,0.82) 0%, rgba(255,193,7,0.78) 45%, rgba(255,234,112,0.70) 100%)',
  color: '#3A0C6E', // violeta fuerte (alta legibilidad)
  border: '1px solid rgba(255,215,0,0.70)',
  textShadow: '0 1px 0 rgba(255,255,255,0.35)',

  boxShadow: '0 10px 22px rgba(0,0,0,0.28), 0 0 0 1px rgba(255,255,255,0.05) inset',
  transition: 'transform .18s ease, box-shadow .25s ease, filter .18s ease',
};

const emojiButtonBadge = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 24,
  height: 24,
  marginRight: 8,
  borderRadius: '50%',
  background: 'rgba(255,255,255,0.2)',
  border: '1px solid rgba(218,165,32,0.6)',
  fontSize: 16,
  lineHeight: 1,
  boxShadow: '0 2px 4px rgba(0,0,0,0.25)',
};

const emojiButtonBadgeGold = {
  ...emojiButtonBadge,
  background: 'rgba(75,0,130,0.2)', // violeta sutil para botones dorados
  border: '1px solid rgba(75,0,130,0.5)',
  flexShrink: 0,
};

export {
  leaderboardButtonBase,
  leaderboardButtonActive,
  supportFabStyle,
  feedFabStyle,
  zodiacCrushFabStyle,
  forumBellFabStyle,
  forumBellBadgeStyle,
  containerStyle,
  overlayStyle,
  buttonStyle,
  emojiButtonBadge,
  emojiButtonBadgeGold,
  hoverIn,
  hoverOut,
  pressIn,
  pressOut,
  focusIn,
  focusOut,
};
